import { SET_PLANOS_PENDENCIAS, SET_PLANOS_COTAS } from './types';

export const setPendencias = pendencias => ({ type: SET_PLANOS_PENDENCIAS, payload: pendencias })
export const setCotas = cotas => ({ type: SET_PLANOS_COTAS, payload: cotas })